"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _actions = require("egov-ui-kit/redux/app/actions");

var _actions2 = require("egov-ui-kit/redux/common/actions");

var _actions3 = require("egov-ui-kit/redux/form/actions");

var _commons = require("egov-ui-kit/utils/commons");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _filter = require("lodash/filter");

var _filter2 = _interopRequireDefault(_filter);

var _actions4 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _sortBy = require("lodash/sortBy");

var _sortBy2 = _interopRequireDefault(_sortBy);

var _api = require("egov-ui-framework/ui-utils/api");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wardStaticData = [{
  name: "010",
  code: "10",
  active: true,
  borough: "2",
  office: [{
    name: "A.C NORTH",
    code: "1"
  }],
  street: [{
    name: "ABHOY GHOSE LANE",
    code: "1"
  }, {
    name: "ANANDA LANE",
    code: "2"
  }]
}, {
  name: "001",
  code: "001",
  active: true,
  borough: "1",
  office: [{
    name: "A.C NORTH",
    code: "1"
  }],
  street: [{
    name: "BARRACKPORE TRUNK ROAD",
    code: "08"
  }, {
    name: "CHANDRA KUMAR ROY LANE",
    code: "2"
  }, {
    name: "COSSIPORE ROAD",
    code: "3"
  }, {
    name: "GOBINDA MONDAL ROAD",
    code: "4"
  }, {
    name: "GOPAL CHANDRA CHATTERJEE ROAD",
    code: "5"
  }, {
    name: "GOPI MONDAL LANE",
    code: "6"
  }, {
    name: "KASI NATH DUTT ROAD",
    code: "7"
  }, {
    name: "KASISWAR CHATTERJEE LANE",
    code: "8"
  }, {
    name: "KHAGENDRA CHATTERJEE ROAD",
    code: "9"
  }, {
    name: "NAFAR CHANDRA LAHA LANE",
    code: "10"
  }, {
    name: "NARENDRA NATH PAUL ROAD",
    code: "11"
  }, {
    name: "PARAMANICK GHAT LANE",
    code: "12"
  }, {
    name: "PRAMANICK GHAT ROAD",
    code: "13"
  }, {
    name: "PRANNATH CHOWDHURY LANE",
    code: "009"
  }, {
    name: "PRANNATH SUR LANE",
    code: "15"
  }, {
    name: "RADHA MOHAN DE LANE",
    code: "16"
  }, {
    name: "RAJENDRA NATH ROY CHOWDHURY LANE",
    code: "17"
  }, {
    name: "RATAN BABU ROAD",
    code: "18"
  }, {
    name: "RUSTOMJEE PARSEE ROAD",
    code: "19"
  }, {
    name: "SATCHASI PARA LANE",
    code: "20"
  }, {
    name: "SATCHASI PARA ROAD",
    code: "21"
  }, {
    name: "SEALS GARDEN LANE",
    code: "22"
  }, {
    name: "SHAMA CHARAN MAITRA LANE",
    code: "23"
  }, {
    name: "SRISTIDHAR DEY LANE",
    code: "24"
  }, {
    name: "BUSTEE RE HOUSING SCH NO I",
    code: "25"
  }]
}, {
  name: "002",
  code: "2",
  active: true,
  borough: "1",
  office: [{
    name: "A.C NORTH",
    code: "1"
  }],
  street: [{
    name: "BARRACKPORE TRUNK ROAD",
    code: "1"
  }, {
    name: "CENTRE SINTHEE ROAD",
    code: "2"
  }, {
    name: "D GUPTA LANE",
    code: "3"
  }, {
    name: "DUM DUM ROAD",
    code: "4"
  }, {
    name: "DUM DUM STATION ROAD",
    code: "5"
  }, {
    name: "GOPAL CHANDRA BOSE LANE",
    code: "6"
  }, {
    name: "GOUR SUNDER SETT LANE",
    code: "7"
  }, {
    name: "HAREY KRISTA SETT LANE",
    code: "8"
  }, {
    name: "HARISH CHANDRA PAUL LANE",
    code: "9"
  }, {
    name: "HEM DE LANE",
    code: "10"
  }, {
    name: "KALI CHARAN GHOSE ROADs",
    code: "11"
  }, {
    name: "KALI CHARAN SETT LANE",
    code: "12"
  }, {
    name: "KEDAR NATH DAS LANE",
    code: "13"
  }, {
    name: "NORTHERN AVENUE",
    code: "14"
  }, {
    name: "PANCHANANTALA LANE",
    code: "15"
  }, {
    name: "RAJA APURBA KRISTO LANE",
    code: "16"
  }, {
    name: "RAJA BAGAN LANE",
    code: "17"
  }, {
    name: "RAM KRISHNA GHOSE ROAD",
    code: "18"
  }, {
    name: "ROYPARA BYE LANE",
    code: "19"
  }, {
    name: "ROYPARA LANE",
    code: "20"
  }, {
    name: "ROYPARA ROAD",
    code: "21"
  }, {
    name: "SAMAR SARANEE",
    code: "22"
  }, {
    name: "SANTRAPARA LANE",
    code: "23"
  }, {
    name: "SEVEN TANKS LANE",
    code: "24"
  }, {
    name: "GANAPATI SUR SARANI",
    code: "25"
  }]
}, {
  name: "044",
  code: "044",
  active: true,
  borough: "5",
  office: [{
    name: "A.C NORTH",
    code: "1"
  }],
  street: [{
    name: "ANGARIKA DHARMAPALA STREET",
    code: "1"
  }, {
    name: "BEPIN BEHARI GANGULY STREET",
    code: "2"
  }]
}];

var premisesTypeStaticData = [{
  label: "HO Govt",
  value: "08"
}, {
  label: "HO Govt",
  value: "17"
}, {
  label: "Kolkata Proper",
  value: "11"
}, {
  label: "HO Bustee",
  value: "12"
}, {
  label: "Multi Storeyed Building",
  value: "14"
}, {
  label: "Kolkata Port Trust",
  value: "16"
}];

var formConfig = {
  name: "propertyAddress",
  fields: {
    ward: {
      id: "ward",
      jsonPath: "Properties[0].ward",
      required: true,
      localePrefix: true,
      labelsFromLocalisation: true,
      type: "AutocompleteDropdown",
      floatingLabelText: "Ward",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      fullWidth: true,
      hintText: "PT_COMMONS_SELECT_PLACEHOLDER",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      updateDependentFields: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref2) {
          var formKey = _ref2.formKey,
              field = _ref2.field,
              dispatch = _ref2.dispatch,
              state = _ref2.state;
          var getStreetList, dd;
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  getStreetList = function () {
                    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(name) {
                      var payload, selectedWard, streetDropDownDataNew;
                      return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return (0, _api.httpRequest)("post", "/property-services/common/_streetMaster?wardNo=" + name, "", [], {});

                            case 2:
                              payload = _context.sent;
                              selectedWard = payload.data;
                              streetDropDownDataNew = [];

                              selectedWard.map(function (s) {
                                streetDropDownDataNew.push({
                                  name: s.streetName,
                                  code: s.street,
                                  value: s.street,
                                  label: s.streetName,
                                  active: "true"
                                });

                                return streetDropDownDataNew;
                              });
                              dispatch((0, _actions3.setFieldProperty)("propertyAddress", "mohalla", "dropDownData", streetDropDownDataNew));
                              return _context.abrupt("return", streetDropDownDataNew);

                            case 8:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, undefined);
                    }));

                    return function getStreetList(_x2) {
                      return _ref3.apply(this, arguments);
                    };
                  }();

                  if (field.value) {
                    dd = getStreetList(field.value);
                    // dispatch(setFieldProperty("propertyAddress", "mohalla", "dropDownData", dd));
                  } else {
                    dispatch((0, _actions3.setFieldProperty)("propertyAddress", "mohalla", "dropDownData", ""));
                  }

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, undefined);
        }));

        return function updateDependentFields(_x) {
          return _ref.apply(this, arguments);
        };
      }()

      //   updateDependentFields: ({ formKey, field, dispatch, state }) => {
      //     function getStreetList(name) {
      //       let selectedWard = wardStaticData.filter((w) => w.code === name)[0];

      //       let streeDropDownDataNew = [];
      //       selectedWard.street.map((s) => {
      //         streeDropDownDataNew.push({
      //           name: s.name,
      //           code: s.code,
      //           value: s.code,
      //           label: s.name,
      //           active: "true",
      //         });
      //         return streeDropDownDataNew;
      //       });
      //       return streeDropDownDataNew;
      //     }
      //     dispatch(setFieldProperty("propertyAddress", "mohalla", "value", ""));

      //     if (field.value) {
      //       let dd = getStreetList(field.value);
      //       dispatch(prepareFinalObject("Properties[0].ward", field.value));
      //       dispatch(setFieldProperty("propertyAddress", "mohalla", "dropDownData", dd));
      //     } else {
      //       dispatch(setFieldProperty("propertyAddress", "mohalla", "dropDownData", ""));
      //     }
      //   },
    },
    mohalla: {
      id: "mohalla",
      jsonPath: "Properties[0].street",
      type: "singleValueList",
      floatingLabelText: "Street",
      fullWidth: true,
      required: true,
      localePrefix: true,
      labelsFromLocalisation: true,
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      formName: "propertyAddress",
      updateDependentFields: function updateDependentFields(_ref4) {
        // if (field.value) {
        //   dispatch(prepareFinalObject("Properties[0].streetName", field.value));
        // }

        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;
      }
    },

    premisesNo: {
      id: "premisesNo",
      type: "textfield",
      className: "pt-old-pid-text-field",
      jsonPath: "Properties[0].premisesNo",
      floatingLabelText: "Premise Number",
      hintText: "Premise Number",
      required: true,
      numcols: 6,
      errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      toolTipMessage: "PT_OLDPID_TOOLTIP_MESSAGE",
      maxLength: 64,
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        if (field.value) {
          dispatch((0, _actions4.prepareFinalObject)("Properties[0].premisesNo", field.value));
        }
      }
    },

    premisesType: {
      id: "premisesType",
      jsonPath: "Properties[0].premisesType",
      type: "AutocompleteDropdown",
      floatingLabelText: "Premise Type",
      hintText: "Premise Type",
      fullWidth: true,

      required: true,
      localePrefix: true,

      labelsFromLocalisation: false,

      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      formName: "propertyAddress",
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        if (field.value) dispatch((0, _actions4.prepareFinalObject)("Properties[0].premisesType", field.value));
      }
    },

    city: {
      id: "city",
      jsonPath: "PropertiesTemp[0].address.city",
      required: true,
      localePrefix: { moduleName: "tenant", masterName: "tenants" },
      labelsFromLocalisation: true,
      type: "AutocompleteDropdown",
      floatingLabelText: "CORE_COMMON_CITY",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      fullWidth: true,
      hideStyle: true,
      value: "km",
      hintText: "PT_COMMONS_SELECT_PLACEHOLDER",
      numcols: 6,
      gridDefination: {
        xs: 0,
        sm: 0
      }

      //   updateDependentFields: ({ formKey, field, dispatch, state }) => {
      //     dispatch(prepareFormData("Properties[0].tenantId", field.value));
      //     dispatch(
      //       prepareFormData(
      //         "Properties[0].city",
      //         filter(get(state, "common.cities"), (city) => {
      //           return city.code === field.value;
      //         })[0].name
      //       )
      //     );
      //     dispatch(setFieldProperty("propertyAddress", "mohalla", "value", ""));
      //     const moduleValue = field.value;
      //     dispatch(fetchLocalizationLabel(getLocale(), moduleValue, moduleValue));
      //     let requestBody = generalMDMSDataRequestObj(field.value);

      //     dispatch(fetchGeneralMDMSData(requestBody, "PropertyTax", getGeneralMDMSDataDropdownName()));
      //   },
    }
  },

  afterInitForm: function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(action, store, dispatch) {
      var getWardList, getParameterByName, state, payload, wardList, urlParams, getStreetList, data, streetValue;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              getWardList = function getWardList() {
                wardList.map(function (w) {
                  wardDropDownDataStatic.push({
                    name: w.name,
                    code: w.code,
                    label: w.name,
                    value: w.code
                  });
                  return wardDropDownDataStatic;
                });
              };

              //   const wardDropDownData = get(state, "form.propertyAddress.fields.ward.dropDownData", []);
              //   const tenant = get(state, "form.propertyAddress.fields.city.value", null);
              //   const mohallaDropDownData = get(state, "form.propertyAddress.fields.mohalla.dropDownData", []);

              //   if (process.env.REACT_APP_NAME === "Citizen" && tenant && mohallaDropDownData.length == 0) {
              //     const dataFetchConfig = {
              //       url: "egov-location/location/v11/boundarys/_search?hierarchyTypeCode=REVENUE&boundaryType=Locality",
              //       action: "",
              //       queryParams: [
              //         {
              //           key: "tenantId",
              //           value: tenant,
              //         },
              //       ],
              //       requestBody: {},
              //       isDependent: true,
              //       hierarchyType: "REVENUE",
              //     };
              //     fetchDropdownData(dispatch, dataFetchConfig, "propertyAddress", "mohalla", state, true);
              //   }

              getParameterByName = function getParameterByName(name) {
                var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return "";
                return decodeURIComponent(results[2].replace(/\+/g, " "));
              };

              state = store.getState();
              _context3.next = 6;
              return (0, _api.httpRequest)("post", "egov-mdms-service/v1/_search", "", [], {
                MdmsCriteria: {
                  tenantId: "km",
                  moduleDetails: [{
                    moduleName: "PropertyTax",
                    masterDetails: [{
                      name: "ward"
                    }]
                  }]
                }
              });

            case 6:
              payload = _context3.sent;
              wardList = payload.MdmsRes.PropertyTax.ward;


              getWardList();
              dispatch((0, _actions3.setFieldProperty)("propertyAddress", "ward", "dropDownData", wardDropDownDataStatic));
              dispatch((0, _actions3.setFieldProperty)("propertyAddress", "premisesType", "dropDownData", premisesTypeStaticData));
              dispatch((0, _actions3.setFieldProperty)("propertyAddress", "premisesTypeDropDown", "dropDownData", premisesTypeStaticData));urlParams = getParameterByName("isInspection");

              if (urlParams == "yes") {
                getStreetList = function getStreetList(name) {
                  var selectedWard = wardStaticData.filter(function (w) {
                    return w.code === name;
                  })[0];

                  var streeDropDownDataNew = [];
                  selectedWard.street.map(function (s) {
                    streeDropDownDataNew.push({
                      name: s.name,
                      code: s.code,
                      value: s.code,
                      label: s.name,
                      active: "true"
                    });
                    return streeDropDownDataNew;
                  });
                  return streeDropDownDataNew;
                };

                data = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "Properties[0]");
                streetValue = getStreetList(data.ward);


                dispatch((0, _actions3.setFieldProperty)("propertyAddress", "mohalla", "dropDownData", streetValue));

                dispatch((0, _actions3.setFieldProperty)("propertyAddress", "ward", "value", data.ward ? data.ward.toString() : ""));
                dispatch((0, _actions3.setFieldProperty)("propertyAddress", "mohalla", "value", data.streetName ? data.streetName.toString() : ""));
                dispatch((0, _actions3.setFieldProperty)("propertyAddress", "premisesNo", "value", data.premisesNo ? data.premisesNo.toString() : ""));
                dispatch((0, _actions3.setFieldProperty)("propertyAddress", "premisesType", "value", data.premisesType ? data.premisesType : ""));

                dispatch((0, _actions4.prepareFinalObject)("Properties[0].ward", data.ward ? data.ward.toString() : ""));
                dispatch((0, _actions4.prepareFinalObject)("Properties[0].streetName", data.streetName ? data.streetName.toString() : ""));
                dispatch((0, _actions4.prepareFinalObject)("Properties[0].premisesNo", data.premisesNo ? data.premisesNo.toString() : ""));
                dispatch((0, _actions4.prepareFinalObject)("Properties[0].premisesType", data.premisesType ? data.premisesType : ""));
              }

              return _context3.abrupt("return", action);

            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0);
              return _context3.abrupt("return", action);

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, undefined, [[0, 17]]);
    }));

    return function afterInitForm(_x3, _x4, _x5) {
      return _ref7.apply(this, arguments);
    };
  }(),
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPayForInspection/propertyAddress.js
// module id = 1887
// module chunks = 1137